<template>
    <div class="favorites-details">
        <!-- 收藏夹信息 -->
        <div class="favorites-info d-flex justify-content-center">
            <v-btn
                :class="['fall-back', triggerSideNavShow && 'offset']"
                @click="change_router"
            >
                {{ $TL.fallBack }}
            </v-btn>
            <div class="info-wrap">
                <h1 class="favor-name">{{ favoritesName || name }}</h1>
                <p class="desc">{{ favoritesAmount }} {{ $TL.zPictures }}</p>
                <v-btn class="edit-btn" @click="edit_favorites">
                    {{ $TL.editFavorite }}
                </v-btn>
            </div>
        </div>
        <!-- 卡片列表 -->
        <v-panel-content :data-salce="triggerSideNavShow" />
    </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
    name: "favorites-details",

    data() {
        return {
            id: 0,
            name: ""
        };
    },
    computed: {
        ...mapState("favorites", [
            "favoritesName",
            "favoritesId",
            "favoritesAmount"
        ]),
        ...mapState("mixins", ["triggerSideNavShow"]),
        ...mapState("global", [])
    },

    watch: {
        favoritesId(newVal) {
            if (newVal) return;
            this.change_router();
        }
    },
    created() {
        this.refresh_get_info();
        this.get_pictures_data();

        this.$P.$on("updateFavoritesName", (name, id) => {
            this.name = name;
            this.replace_param_val("name", name);
        });

        this.$P.$on("updateFavoritesCount", (count, id) => {
            this.replace_param_val("fav_count", count);
            this.updateFavoritesAmount(count);
        });
    },
    mounted() {},
    beforeDestroy() {
        this.$P.$off("updateFavoritesName");
        this.$P.$off("updateFavoritesCount");
    },

    methods: {
        ...mapMutations("favorites", [
            "updateFavoritesId",
            "updateFavoritesAmount"
        ]),
        ...mapMutations("triggerEvtents", ["updateInitSearchCondition"]),
        get_pictures_data() {
            this.updateInitSearchCondition();
            this.$P.schemaType = "favoritePictures";
        },
        edit_favorites() {
            this.updateFavoritesId(this.favoritesId || this.id);
            this.$store.state.vModal.showType = "editFavorites";
        },
        refresh_get_info() {
            let url = new URL(window.location.href);
            let amount = url.searchParams.get("fav_count");
            this.name = url.searchParams.get("name");
            this.id = url.searchParams.get("id");

            this.updateFavoritesAmount(amount);
            this.updateFavoritesId(this.id);
        },

        replace_param_val(paramName, replaceWith) {
            let oUrl = this.$route.fullPath.toString();
            let re = eval("/(" + paramName + "=)([^&]*)/gi");
            let nUrl = oUrl.replace(re, paramName + "=" + replaceWith);
            window.history.replaceState({}, {}, nUrl);
        },
        change_router() {
            this.$router.push("/favorites");
        }
    }
};
</script>

<style lang="scss">
.favorites-details {
    .favorites-info {
        position: relative;
        padding: {
            top: 24px;
            bottom: 32px;
        }
        .info-wrap {
            @include flex(center, center, wrap, column);
        }

        .favor-name {
            font-size: 38px;
            line-height: 1.2;
        }

        .desc {
            font-size: 14px;
            margin-top: 8px;
        }

        .edit-btn,
        .fall-back {
            padding: 6px 20px;
            border: 1px solid #dfe1e5;
            border-radius: 40px;

            &:hover {
                color: $color-white;
                @include bgc();
            }
        }

        .fall-back {
            position: absolute;
            left: 20px;
            top: 24px;

            &.offset {
                left: 280px;
            }
        }
    }
}
</style>
